import * as React from "react";
import { useOutletContext } from "react-router-dom";
import MobileModuleBreak from "./components/mobile-module-break";
import WebModuleBreak from "./components/web-module-break";

export default function ModuleBreak() {
	const [handleChangeWebStyleLayout, layout] = useOutletContext();

	return (
		<React.Fragment>
			{layout === "mobile" 
				? <MobileModuleBreak />
				: <WebModuleBreak onChangeWebStyleLayout={handleChangeWebStyleLayout}/>
			}
		</React.Fragment>
	);
}
